const metaDescription =
  'The definitive guide for rental home owners including how-tos, tips, and news. Unlock the keys to successful property management.';

export const BLOG_STRINGS = {
  metaTitleWithPagination:
    'Belong Blog | Property Management & Home Rental Guide | Page {page}',
  metaTitle: 'Belong Blog | Property Management & Home Rental Guide',
  metaDescription,
  metaDescriptionWithPagination: `${metaDescription} | Page {page}`,
  'page.title': 'Welcome To The Playroom',
  'page.description':
    "We've named our blog after the most joyful room in the house, because that's the feeling which best describes living in a Belong home. We'll be sharing tips, trends and stories from our community that capture the many ways in which we're making long-term renting a new way of life. One where all people Belong.",
  'card.writtenBy': 'Written By',
  'post.lastUpdated': 'Last Updated',
  'post.aboutAuthor': 'About The Author',
  'post.share': 'Share This Article',
  // MonthYearRentSlice
  unlock: 'Select City To Unlock\u00a0Price',
  'feeText.active': '% is all you pay.',
  'feeText.comingSoon': 'Coming Soon',
  'feeText.TBD': 'TBD',
  feeRange: '${minimum}/Mo. Minimum – ${maximum}/Mo. Maximum',
  tax: 'Tax Deductible',
  'firstOption.type': 'Monthly',
  'firstOption.description':
    "We'll initiate rent on the 1st of each month, no\u00a0matter\u00a0what.",
  'secondOption.type': 'Yearly',
  'secondOption.description':
    "The moment we find someone to love your home, we'll\u00a0pay\u00a0you the entire year's worth of\u00a0income.",
  // HomeownersWidget
  'hoWidget.title': 'You own a home.\nWe have someone to love it.',
  'hoWidget.titleLine1': 'You own a home.',
  'hoWidget.titleLine2': 'We have someone to love it.',
  'hoWidget.cta1label': 'Learn More',
  'hoWidget.cta2label': 'Get Started',
  relatedArticles: 'Related Articles',
  allArticles: 'All Articles',
  featuredArticles: 'Featured Articles',
};

export const BLOG_AUTHOR_STRINGS = {
  authorName: "{authorName}'s Articles",
  metaTitle: 'Meet {authorFullName} Author | Belong Blog',
  metaTitleWithPagination:
    'Meet {authorFullName} Author | Belong Blog | Page {page}',
  metaDescriptionWithPagination: '{aboutAuthor} | Page {page}',
};

export const BLOG_CONTENT_STRINGS = {
  tableContents: 'Table Of Contents',
  contents: 'Contents',
};
